import axios from 'axios';
import qs from 'qs';

// Create axios instance for PHP endpoints
const rootApp = axios.create({
  baseURL: ''
});

// People management endpoints - using DomainPeopleController for proper user management
const listPeople = ({ body }) =>
  rootApp.post('/index.php?r=domainPeople/listPeople', qs.stringify(body, { arrayFormat: 'brackets' }));

const getPerson = ({ id }) =>
  rootApp.post('/index.php?r=domainPeople/getPerson', qs.stringify({ id }));

const createPerson = ({ body }) =>
  rootApp.post('/index.php?r=domainPeople/create', qs.stringify(body));

const updatePerson = ({ id, body }) => {
  // Use the new DomainPeopleController endpoint that supports password updates
  const payload = {
    id: id,
    name: body.name,
    lastname: body.lastname,
    email: body.email,
    username: body.username,
    level_access: body.level_access
  };

  // Add optional fields if provided
  if (body.password) {
    payload.password = body.password;
  }
  if (body.is_activated !== undefined) {
    payload.is_activated = body.is_activated;
  }
  if (body.id_people) {
    payload.id_people = body.id_people;
  }

  return rootApp.post('/index.php?r=domainPeople/updatePerson', qs.stringify(payload));
};

const deletePerson = ({ id }) =>
  rootApp.post('/index.php?r=people/deleteUser', qs.stringify({ id_user: id }));

const exportPeople = ({ body }) =>
  rootApp.get('/index.php?r=people/downloadCsv', {
    params: body,
    responseType: 'blob'
  });

const importPeople = ({ file, body }) => {
  const formData = new FormData();
  formData.append('csv_file', file);
  Object.keys(body).forEach(key => {
    formData.append(key, body[key]);
  });

  return rootApp.post('/index.php?r=coursePeopleTeam/ProcessUploadFile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// Get teams for a person
const getPersonTeams = ({ id }) =>
  rootApp.post('/index.php?r=team/GetTeamsForUser', qs.stringify({ id_user: id }));

// Get courses for a person
const getPersonCourses = ({ id, body }) =>
  rootApp.post(`/index.php?r=report/ListUserCourses/id/${id}/limit/10&page=1`, qs.stringify(body));

// Update profile picture
const updateProfilePicture = ({ id, image }) => {
  const formData = new FormData();
  formData.append('image', image);
  formData.append('id', id);

  return rootApp.post('/index.php?r=people/updateProfilepicture', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// Assign person to team
const assignToTeam = ({ body }) =>
  rootApp.post('/index.php?r=team/AddPeopleTeam', qs.stringify(body));

// Remove person from team
const removeFromTeam = ({ body }) =>
  rootApp.post('/index.php?r=team/RemovePeopleTeam', qs.stringify(body));

// Assign person to course
const assignToCourse = ({ courseId, body }) =>
  rootApp.post(`/index.php?r=people/AsignPeopleToCourse&id=${courseId}`, qs.stringify(body, { arrayFormat: 'brackets' }));

// Remove person from course
const removeFromCourse = ({ body }) => {
    var xsrfMatch = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
    var xsrfToken = xsrfMatch ? xsrfMatch[1] : '';
    xsrfToken = xsrfToken !== '' ? xsrfToken : (typeof XSRF_TOKEN !== 'undefined') ? XSRF_TOKEN : '';
    return rootApp.post('/index.php?r=CoursePeople/RemovePeopleCourse&id=7', qs.stringify({...body, 'X-XSRF-TOKEN': xsrfToken}));
};

// Send welcome email
const sendWelcomeEmail = ({ body }) =>
  rootApp.post('/index.php?r=coursePeopleTeam/SendWelcomeEmail', qs.stringify(body));

// Reset password
const resetPassword = ({ body }) =>
  rootApp.post('/index.php?r=people/ResetPassword', qs.stringify(body));

// Get activity log for a person
const getPersonActivity = ({ id, body }) =>
  rootApp.post('/index.php?r=report/UserActivity', qs.stringify({ ...body, id_user: id }));

// Bulk operations
const bulkDelete = ({ body }) =>
  rootApp.post('/index.php?r=people/BulkDelete', qs.stringify(body, { arrayFormat: 'brackets' }));

const bulkAssignRole = ({ body }) =>
  rootApp.post('/index.php?r=people/BulkAssignRole', qs.stringify(body, { arrayFormat: 'brackets' }));

const bulkAssignTeam = ({ body }) =>
  rootApp.post('/index.php?r=team/BulkAssignTeam', qs.stringify(body, { arrayFormat: 'brackets' }));

// Search users (autocomplete)
const searchUsers = ({ query }) =>
  rootApp.post('/index.php?r=people/SearchUsers', qs.stringify({ q: query }));

// Get user statistics
const getUserStats = ({ id }) =>
  rootApp.get(`/index.php?r=report/UserStatistics&id=${id}`);

// Validate unique email
const validateEmail = ({ email, id_corporation }) =>
  rootApp.post('/index.php?r=people/ValidateEmail', qs.stringify({ email, id_corporation }));

// Validate unique username
const validateUsername = ({ username, id_corporation }) =>
  rootApp.post('/index.php?r=people/ValidateUsername', qs.stringify({ username, id_corporation }));

export default {
  listPeople,
  getPerson,
  createPerson,
  updatePerson,
  deletePerson,
  exportPeople,
  importPeople,
  getPersonTeams,
  getPersonCourses,
  updateProfilePicture,
  assignToTeam,
  removeFromTeam,
  assignToCourse,
  removeFromCourse,
  sendWelcomeEmail,
  resetPassword,
  getPersonActivity,
  bulkDelete,
  bulkAssignRole,
  bulkAssignTeam,
  searchUsers,
  getUserStats,
  validateEmail,
  validateUsername
};